import AppACL from '@/plugins/acl/ACL'
import { AuthLayout, DefaultLayout, PrintLayout } from '@/components/layouts'
import SessionHelper from '@/helpers/SessionHelper'

export const publicRoute = [
  {
    path: '*',
    component: () => import('@/views/error/NotFound.vue'),
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { title: 'Login' },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { title: 'Login' },
        component: () => import('@/views/auth/Login.vue'),
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    meta: { title: 'Not Found' },
    component: () => import('@/views/error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: { title: 'Server Error' },
    component: () => import('@/views/error/Error.vue'),
  },
]

export const protectedRoute = [
  {
    path: '/',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: { title: 'Root' },
    children: [
      {
        path: '403',
        name: 'Forbidden',
        meta: { title: '403' },
        component: () => import('@/views/error/Deny.vue'),
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: {
          title: 'Dashboard',
          roles: [
            AppACL.ROLE.GEM,
            AppACL.ROLE.ADM,
            AppACL.ROLE.COL,
            AppACL.ROLE.DIST,
            AppACL.ROLE.LAB,
          ],
        },
        component: () => import('@/views/Dashboard.vue'),
      },

      {
        path: 'cliente/:view',
        name: 'ClientWorkspace',
        meta: {
          title: 'Mi operación',
          roles: [AppACL.ROLE.DIST, AppACL.ROLE.LAB],
        },
        component: () => import('@/views/dashboard/ClientDashboard.vue'),
      },
      {
        path: 'notificaciones',
        name: 'Notificaciones',
        meta: {
          title: 'Notificaciones',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: () => import('@/views/Notificaciones.vue'),
      },

      {
        path: 'logs',
        name: 'Logs',
        meta: {
          title: 'Logs',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: () => import('@/views/Logs.vue'),
      },

      // Seccion de Laboratorios
      {
        path: 'laboratorios',
        name: 'Laboratorios',
        redirect: '/laboratorios/listado',
        meta: {
          title: 'Laboratorios',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Laboratorios',
            meta: {
              title: 'Listado de Laboratorios',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Laboratorio',
            meta: {
              title: 'Nuevo Laboratorio',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Laboratorio',
            meta: {
              title: 'Editar Laboratorio',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/Form.vue'),
          },
        ],
      },
      // Seccion de Distribuidores
      {
        path: 'distribuidores',
        name: 'Distribuidores',
        redirect: '/distribuidores/listado',
        meta: {
          title: 'Distribuidores',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Distribuidores',
            meta: {
              title: 'Listado de Distribuidores',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Distribuidor',
            meta: {
              title: 'Nuevo Distribuidor',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Distribuidor',
            meta: {
              title: 'Editar Distribuidor',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/Form.vue'),
          },
        ],
      },

      // Seccion de Productos
      {
        path: 'productos',
        name: 'Productos',
        redirect: '/productos/listado',
        meta: { title: 'Productos' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Productos',
            meta: {
              title: 'Listado de Productos',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Producto',
            meta: {
              title: 'Nuevo Producto',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Form.vue'),
          },
          {
            path: 'expirados',
            name: 'Productos Expirados',
            meta: {
              title: 'Productos Expirados',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Expired.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Producto',
            meta: {
              title: 'Editar Producto',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Form.vue'),
          },
        ],
      },

      // Seccion de Usuarios
      {
        path: 'usuarios',
        name: 'Usuarios',
        redirect: '/productos/listado',
        meta: { title: 'Usuarios' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Usuarios',
            meta: {
              title: 'Listado de Usuarios',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Usuario',
            meta: {
              title: 'Nuevo Usuario',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Usuario',
            meta: {
              title: 'Editar Usuario',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/Form.vue'),
          },
        ],
      },

      // Seccion de Facturas
      {
        path: 'facturas',
        name: 'Facturas',
        redirect: '/facturas/listado',
        meta: { title: 'Facturas' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Facturas',
            meta: {
              title: 'Listado de Facturas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nueva-Factura',
            meta: {
              title: 'Nueva Factura',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Factura',
            meta: {
              title: 'Editar Factura',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/Form.vue'),
          },
          {
            path: 'manual',
            name: 'Manual-Facturas',
            meta: {
              title: 'Cómo crear una factura',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/Manual.vue'),
          },
        ],
      },

      // Seccion de Transit
      {
        path: 'transit',
        name: 'Transit',
        redirect: '/transit/facturas',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'facturas',
            name: 'Transit-Facturas',
            meta: {
              title: 'Facturas',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.DIST,
                AppACL.ROLE.LAB,
                AppACL.ROLE.COL,
              ],
            },
            component: () => import('@/views/transit/Facturas.vue'),
          },

          {
            path: 'f&d',
            name: 'F&D',
            meta: {
              title: 'Trámites en Proceso',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/F&D.vue'),
          },
          {
            path: 'reingresos',
            name: 'Reingresos',
            meta: {
              title: 'Trámites para Reingreso',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/Reingresos.vue'),
          },
          {
            path: 'aprobadas',
            name: 'Aprobadas',
            meta: {
              title: 'Aprobadas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/Aprobadas.vue'),
          },
          {
            path: 'rechazadas',
            name: 'Rechazadas',
            meta: {
              title: 'Rechazadas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/Rechazadas.vue'),
          },
          // La pantalla de Pago de Impuestos vive en Contabilidad: es la que
          // tiene el monto en el diálogo del comprobante, el semáforo y el
          // diseño del consolidado. Esta ruta vieja se mantiene solo para no
          // romper enlaces guardados y menús que aún la apunten.
          {
            path: 'pago-de-impuestos',
            name: 'PagoImpuestos',
            redirect: '/contabilidad/pago-de-impuestos',
          },
          {
            path: 'entregas',
            name: 'Entregas',
            meta: {
              title: 'Entregas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.ENT],
            },
            component: () => import('@/views/transit/Entregas.vue'),
          },

          {
            path: 'ver-facturas',
            name: 'Transit-Clientes',
            meta: {
              title: 'Gestión Aduanera',
              roles: [AppACL.ROLE.DIST, AppACL.ROLE.LAB],
            },
            component: () => {
              if (SessionHelper.role === 'LAB')
                return import('@/views/transit/FacturasLaboratorio.vue')
              if (SessionHelper.role === 'DIST')
                return import('@/views/transit/FacturasDistribuidor.vue')
            },
          },
        ],
      },

      // Seccion de Contabilidad
      {
        path: 'contabilidad',
        name: 'Contabilidad',
        redirect: '/contabilidad/pago-de-impuestos',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'pago-de-impuestos',
            name: 'ContabilidadPagoImpuestos',
            meta: {
              title: 'Pago de Impuestos',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.PAG],
            },
            component: () => import('@/views/contabilidad/PagoImpuestos.vue'),
          },
          {
            path: 'cliente',
            name: 'ContabilidadCliente',
            meta: { title: 'Contabilidad', roles: [AppACL.ROLE.DIST] },
            component: () => import('@/views/transit/FacturasDistribuidor.vue'),
          },
          {
            path: 'tarifas',
            name: 'ContabilidadTarifas',
            meta: {
              title: 'Tarifa de Corretaje',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.PAG],
            },
            component: () => import('@/views/contabilidad/Tarifas.vue'),
          },
          {
            path: 'reembolsos',
            name: 'ContabilidadReembolsos',
            meta: {
              title: 'Facturación de Reembolso',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.PAG],
            },
            component: () => import('@/views/contabilidad/Reembolsos.vue'),
          },
          {
            path: 'facturacion-servicios',
            name: 'ContabilidadFacturacionServicios',
            meta: {
              title: 'Facturación por Servicios',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.PAG],
            },
            component: () =>
              import('@/views/contabilidad/FacturacionServicios.vue'),
          },
          {
            path: 'estado-de-cuenta',
            name: 'ContabilidadEstadoCuenta',
            meta: {
              title: 'Estado de Cuenta',
              // El cliente entra a ver lo suyo: el backend le recorta el
              // alcance y la pantalla le oculta las acciones de Transit.
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.PAG,
                AppACL.ROLE.LAB,
                AppACL.ROLE.DIST,
              ],
            },
            component: () => import('@/views/contabilidad/EstadoCuenta.vue'),
          },
        ],
      },

      // Seccion de Reportes
      {
        path: 'reportes',
        name: 'Reportes',
        redirect: '/reportes/cartera-pendiente',
        meta: {
          title: 'Reportes',
          roles: [
            AppACL.ROLE.GEM,
            AppACL.ROLE.ADM,
            AppACL.ROLE.COL,
            AppACL.ROLE.LAB,
            AppACL.ROLE.DIST,
          ],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'cartera-pendiente',
            name: 'Reporte-Cartera-Pendiente',
            meta: {
              title: 'Cartera pendiente',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.COL,
                AppACL.ROLE.LAB,
                AppACL.ROLE.DIST,
              ],
            },
            component: () => import('@/views/reportes/CarteraPendiente.vue'),
          },
          {
            path: 'vencimientos',
            name: 'Reporte-Vencimientos',
            meta: {
              title: 'Vencimientos de lotes',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.COL,
                AppACL.ROLE.LAB,
              ],
            },
            component: () => import('@/views/reportes/Vencimientos.vue'),
          },
          {
            path: 'clientes',
            name: 'Reporte-Clientes',
            meta: {
              title: 'Volumen por cliente',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.COL,
                AppACL.ROLE.LAB,
                AppACL.ROLE.DIST,
              ],
            },
            component: () => import('@/views/reportes/Clientes.vue'),
          },
          {
            path: 'rechazos',
            name: 'Reporte-Rechazos',
            meta: {
              title: 'Rechazos',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.COL,
                AppACL.ROLE.LAB,
                AppACL.ROLE.DIST,
              ],
            },
            component: () => import('@/views/reportes/Rechazos.vue'),
          },
          {
            path: 'guia',
            name: 'Reporte-Guia',
            meta: {
              title: 'Cómo leer los reportes',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.COL,
                AppACL.ROLE.LAB,
                AppACL.ROLE.DIST,
              ],
            },
            component: () => import('@/views/reportes/Guia.vue'),
          },
        ],
      },

      // Logística: las rutas antiguas conservan enlaces guardados.
      {
        path: 'logistica',
        component: { render: c => c('router-view') },
        meta: {
          title: 'Logística',
          roles: ['GEM', 'ADM', 'TRA', 'MENSAJERO', 'ENT'],
        },
        redirect: () =>
          SessionHelper.role === 'TRA'
            ? '/logistica/transportista'
            : '/logistica/mensajeria',
        children: [
          {
            path: 'mensajeria',
            name: 'Logistica-Mensajeria',
            meta: {
              title: 'Mensajería',
              roles: ['GEM', 'ADM', 'MENSAJERO', 'ENT'],
            },
            component: () => import('@/views/envios/List.vue'),
          },
          {
            path: 'transportista',
            name: 'Logistica-Transportista',
            meta: { title: 'Transportista', roles: ['GEM', 'ADM', 'TRA'] },
            component: () => import('@/views/envios/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Logistica-Nuevo',
            meta: {
              title: 'Nuevo servicio de logística',
              roles: ['GEM', 'ADM'],
            },
            component: () => import('@/views/envios/Form.vue'),
          },
          {
            path: 'servicio/:id',
            name: 'Logistica-Detalle',
            meta: {
              title: 'Detalle de logística',
              roles: ['GEM', 'ADM', 'TRA', 'MENSAJERO', 'ENT'],
            },
            component: () => import('@/views/envios/Detail.vue'),
          },
        ],
      },
      {
        path: 'envios',
        name: 'Envios',
        redirect: '/logistica/mensajeria',
        meta: {
          title: 'Envíos',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            redirect: '/logistica/mensajeria',
            name: 'Listado-Envios',
            meta: {
              title: 'Listado de Envíos',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/envios/List.vue'),
          },
          {
            path: 'nuevo',
            redirect: to => ({ path: '/logistica/nuevo', query: to.query }),
            name: 'Nuevo-Envio',
            meta: {
              title: 'Nuevo Envío',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/envios/Form.vue'),
          },
          {
            path: ':id',
            redirect: to => `/logistica/servicio/${to.params.id}`,
            name: 'Detalle-Envio',
            meta: {
              title: 'Detalle de Envío',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/envios/Detail.vue'),
          },
        ],
      },

      // Seccion de Administración (Solo Admin - GEM)
      {
        path: 'admin',
        name: 'Administración',
        redirect: '/admin/menus',
        meta: {
          title: 'Administración',
          roles: [AppACL.ROLE.GEM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'menus',
            name: 'Menus',
            meta: {
              title: 'Gestión de Menús',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/Menus.vue'),
          },
          {
            path: 'roles',
            name: 'Roles',
            meta: {
              title: 'Gestión de Roles',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/Roles.vue'),
          },
          {
            path: 'usuarios-admin',
            name: 'UsuariosAdmin',
            meta: {
              title: 'Gestión de Usuarios',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/Users.vue'),
          },
          {
            path: 'organos-anuentes',
            name: 'OrganosAnuentes',
            meta: {
              title: 'Gestión de Órganos Anuentes',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/OrganosAnuentes.vue'),
          },
          {
            path: 'transportistas',
            name: 'Transportistas',
            meta: {
              title: 'Gestión de Transportistas',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/Transportistas.vue'),
          },
          {
            path: 'motivos-pendientes',
            name: 'MotivosPendientes',
            meta: {
              title: 'Motivos de pendiente',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/PendingReasons.vue'),
          },
          {
            path: 'documentos-transporte',
            name: 'DocumentosTransporte',
            meta: {
              title: 'Documentos de Transporte',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/DocumentosTransporte.vue'),
          },
          {
            path: 'feriados',
            name: 'Feriados',
            meta: {
              title: 'Feriados',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/Feriados.vue'),
          },
          {
            path: 'bitacoras',
            name: 'BitacoraTemplates',
            meta: {
              title: 'Plantillas de Bitácora',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/BitacoraTemplates.vue'),
          },
          {
            path: 'bitacoras/nuevo',
            name: 'BitacoraTemplate-Nuevo',
            meta: {
              title: 'Nueva Plantilla de Bitácora',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/BitacoraTemplateForm.vue'),
          },
          {
            path: 'bitacoras/editar/:id',
            name: 'BitacoraTemplate-Editar',
            meta: {
              title: 'Editar Plantilla de Bitácora',
              roles: [AppACL.ROLE.GEM],
            },
            component: () => import('@/views/admin/BitacoraTemplateForm.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/print-invoice/:id',
    name: 'PrintInvoice',
    meta: {
      title: 'Print Invoice',
      roles: [
        AppACL.ROLE.ADM,
        AppACL.ROLE.GEM,
        AppACL.ROLE.DIST,
        AppACL.ROLE.LAB,
      ],
    },
    component: PrintLayout,
  },
]
